module.exports = __webpack_public_path__ + "img/phase2-gallery-06.c6fd624d.png";